
import { defineComponent, PropType, ref, onMounted, onUpdated, onBeforeUpdate } from 'vue'

interface InputSelectOption {
  value: string | number;
  display: string | number;
}

export default defineComponent({
  name: 'InputSelectHorizontal',
  emits: ['update:modelValue', 'select'],
  props: {
    modelValue: [String, Number, Boolean] as PropType<string | number | null>,
    options: {
      type: Object as PropType<InputSelectOption[]>,
      required: true
    }
  },
  setup(props, { emit }) {
    const selected = ref<InputSelectOption | null>(null)
    const sliderRef = ref<HTMLElement | null>(null)
    let optionRefs: HTMLElement[] = []
    
    // Get template ref for each option
    onBeforeUpdate(() => optionRefs = [])
    function setOptionRef(el: HTMLElement) {
      optionRefs.push(el)
    }

    function updateSlider(el: HTMLElement) {       
      sliderRef.value && sliderRef.value.setAttribute('style', 'width:' + el.offsetWidth + 'px;' + 'transform: translateX(' + el.offsetLeft + 'px)')
    }


    function selectOption(i: number, evt: Event) {
      selected.value = props.options[i]
      emit('update:modelValue', props.options[i].value)
      emit('select', props.options[i].value)
      evt.target && updateSlider(evt.target as HTMLElement)
    }

    onMounted(() => {  
      const selectedIndex = props.options.findIndex(obj => obj.value === props.modelValue) || 0
      selected.value = props.options[selectedIndex]
      const el = optionRefs[selectedIndex]          
      el && updateSlider(el)
    })

    return { selectOption, selected, sliderRef, optionRefs, setOptionRef }
  }
})
